<!--  -->
<template>
  <div>
    <div class="table_box">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="资源名称"
          width="180"
          align="center"
        />
        <el-table-column
          prop="money"
          label="赠送看点数量"
          width="180"
          align="center"
        />
        <el-table-column
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="chooseitem(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="total"
      :page-sizes="[100]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { acawraccountlist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      tableDatatwo: [],
      total: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(val) {
      console.log('this.platformid', val)
      this.getlist(val)
    },
    async getlist(id) {
      const data = await acawraccountlist({
        platformId: id,
        activityType: 4
      })
      this.tableData = data.data.resources.slice(0, 100)
      this.tableDatatwo = data.data.resources
      this.total = data.data.resources.length
      console.log(data.data.resources.slice(0, 100))
      console.log('datar', data.data.resources.slice(100))
    },
    // 分页
    fetchPageSize(e) {
      console.log('e1', e)
      // this.pageIfonlist.pageSize = e
      // this.getlistw()
    },
    fetchCurrentPage(e) {
      console.log('e2', e)
      this.tableData = []
      // eslint-disable-next-line eqeqeq
      if (e == 1) {
        this.tableData = this.tableDatatwo.slice(0, 100)
      } else {
        this.tableData = this.tableDatatwo.slice(100)
      }
      // this.pageIfonlist.page = e
      // this.getlistw()
    },
    chooseitem(item) {
      console.log('item', item)
      this.$emit('callback', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.table_box{
  height: 400px;
  overflow: hidden;
  overflow-y: scroll
}
</style>
